// src/api/sitesService.js ver 02 Dec 17 2025 2:00 pm - SB118b
// src/api/sitesService.js ver 01 Dec 16 2025 11:20 pm - SB118a
import { callCloudFunction } from './apiClient';

export const getSites = async (tenantid, token, page = 1, limit = 20, categoryFilter = 'no-filter', statusFilter = 'Active') => {
  return callCloudFunction('sitesCrud', 'GET', null, null, token, null,{
      pathParams: { tenantid, operation: 'list' },
      queryParams: { page, limit, categoryfilter: categoryFilter, statusfilter: statusFilter }
  });
};

export const getSiteById = async (tenantid, id, token) => {
  return callCloudFunction('sitesCrud', 'GET', null, id, token, null,{
      pathParams: { tenantid, operation: 'getById', id }
  });
};

export const addSite = async (tenantid, siteData, token) => {
  return callCloudFunction('sitesCrud', 'POST', siteData, null, token, null,{
      pathParams: { tenantid, operation: 'add' }
  });
};

export const updateSite = async (tenantid, id, siteData, token) => {
  return callCloudFunction('sitesCrud', 'PUT', siteData, null, token, null,{
      pathParams: { tenantid, operation: 'update', id }
  });
};

// // NEW: Helper to fetch all active regular employees for dropdown in SitesForm
// export const getAllActiveRegularEmployeesForDropdown = async (tenantid, token) => {
//     // Calls a specific helper function endpoint
//     return callCloudFunction('getAllEmployeesForDropdown', 'GET', null, null, token, null,{
//         queryParams: { tenantid } // Pass tenantid as query param
//     });
// };
// UPDATED ver 01: Helper to fetch all active regular employees for dropdown in SitesForm
// export const getAllActiveRegularEmployeesForDropdown = async (tenantid, token) => {
//     // Calls the employeesCrud 'listActvEmpNmIds' operation directly
//     // return callCloudFunction('listActiveEmployeeNamesAndIds', 'GET', null, null, token, {
//     return callCloudFunction('employeesCrud', 'GET', null, null, token, null,{
//         pathParams: { tenantid, operation: 'listActvEmpNmIds' } // NEW: operation is part of pathParams
//     });
// };  // REMOVE ver 02 - SB118